import React from 'react';
import PropTypes from 'prop-types';
import { Upload as AntUpload } from 'antd';

import Client from 'containers/app/client';
import { beforeUpload } from './utils';

const Upload = ({ className, uploadTo, children, ...rest }) => {
  const customRequest = e => {
    Client.upload({ ...e, uploadTo });
  };

  return (
    <AntUpload
      beforeUpload={beforeUpload}
      customRequest={customRequest}
      {...rest}
    >
      <div className={className}>{children}</div>
    </AntUpload>
  );
};

Upload.propTypes = {
  uploadTo: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

Upload.defaultProps = {
  className: undefined,
  children: undefined,
};

export default Upload;
